/* eslint-disable camelcase */
import { usePage } from "PFApp/use_page";
import { Id } from "PFTypes/id";
import { SamlConfig } from "PFTypes/saml_config";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { getSamlConfig, NewSamlConfig } from "../services/saml_configs_api";

const initPage = { samlConfig: null, loaded: false, errors: [] };

type SamlConfigPage = {
  loaded: boolean;
  samlConfig: SamlConfig | NewSamlConfig | null;
  errors: string[];
};

export const useEditSamlConfig = (id: Id) => {
  const { t } = useTranslation();
  const { page, setPage, mergePage, resetPage } = usePage<SamlConfigPage>(
    id ? `saml_configs/${id}/edit` : "saml_configs/new",
    initPage
  );

  const fetch = ({ id }) => {
    if (id) {
      getSamlConfig(id)
        .then((response) => {
          mergePage({
            loaded: true,
            samlConfig: response
          });
        })
        .catch(() =>
          mergePage({
            loaded: true,
            errors: [t("thereWasAnError")]
          })
        );
    } else {
      mergePage({
        loaded: true,
        samlConfig: {
          active: false,
          authn_context: "",
          idp_cert: "",
          idp_cert_fingerprint: "",
          idp_entity_id: "",
          idp_slo_service_url: "",
          idp_sso_service_url: "",
          issuer: "",
          metadata_url: "",
          name_identifier_format: "",
          service_provider_metadata: "",
          validate_recipient: false
        }
      });
    }
  };

  useEffect(() => {
    setPage(initPage);
    return resetPage;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetch({ id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { ...page };
};
